import { styled, Button } from '@mui/material';
import GooglePayButton from 'assets/icons/GooglePayButton';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';

export const StyledButton = styled(Button)`
  background-color: ${palette.blue[500]};
  border: none;
  justify-content: left;
  padding: ${theme.spacing(1)} 0 0 0;
`;

export const StyledGooglePayButton = styled(GooglePayButton)`
  margin-left: -3px;
`;
